module.exports = __webpack_public_path__ + "44.11a0c907baa5666c13ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/wedding-shots/44.jpg
// module id = ./src/assets/images/private/wedding-shots/44.jpg
// module chunks = main